export enum ActionType {
  Acesso = 176,
  SuporteChat = 177,
  GrupoMontadora = 178,
  Suporte = 180,
  LeadTime = 181,
}